// extracted by mini-css-extract-plugin
module.exports = {"container":"_5AWHfc9IApGuXZ5XUshgRQ==","icon":"Yi+qL5vjSmphBNaFKkyVxA==","copy":"JPrtZ0UzdOOP9eDT+9ol5Q=="};